import { scrollTargetElementType } from "./ScrollTargetElement.js";
const scrollTargetToolbarButton = {
  elementType: scrollTargetElementType,
  label: "Scroll target",
  title: "Scroll target",
  blueprintIcon: "locate"
};
export {
  scrollTargetToolbarButton
};
//# sourceMappingURL=scrollTargetToolbarButton.js.map
